import React from 'react'
import LotteryResultSectionHeader from '../LotteryResultSectionHeader'
import { getImageUrl } from '../../../utils/cdnUtils'

const FOREIGN_STOCK_ITEMS: { icon: string; title: string }[] = [
  { icon: 'flag/us.png', title: 'หุ้นดาวน์โจนส์' },
  { icon: 'flag/jp.png', title: 'หุ้นนิเคอิรอบเช้า' },
  { icon: 'flag/cn.png', title: 'จีนรอบเช้า' },
  { icon: 'flag/hk.png', title: 'ฮั่งเส็งรอบเช้า' },
  { icon: 'flag/tw.png', title: 'หุ้นไต้หวัน' },
  { icon: 'flag/sk.png', title: 'หุ้นเกาหลี' },
  { icon: 'flag/jp.png', title: 'นิเคอิปิดบ่าย' },
  { icon: 'flag/cn.png', title: 'จีนปิดรอบบ่าย' },
  { icon: 'flag/hk.png', title: 'ฮั่งเส็งปิดบ่าย' },
  { icon: 'flag/sp.png', title: 'หุ้นสิงคโปร์' },
  { icon: 'flag/id.png', title: 'หุ้นอินเดีย' },
  { icon: 'flag/eg.png', title: 'หุ้นอิยิปต์' },
  { icon: 'flag/rs.png', title: 'หุ้นรัสเซีย' },
  { icon: 'flag/gm.png', title: 'หุ้นเยอรมัน' },
  { icon: 'flag/en.png', title: 'หุ้นอังกฤษ' },
]

/** Static mock section: หวยหุ้น */
const LotteryResultStaticForeignStock: React.FC = () => (
  <div className="col-12 px--1 mb-4">
    <LotteryResultSectionHeader
      title="หวยหุ้น"
      iconUrl="logo.png"
      drawLabel="14-Aug-2024"
    />
    <div className="wrap-box p-2 pt-0 bgc-14 bdr-5">
      <div className="row mx--1">
        {FOREIGN_STOCK_ITEMS.map(({ icon, title }) => (
          <div
            key={title}
            className="col-6 col-lg-3 px-1 mt-2 animateMe"
            data-animation="fadeInUp"
          >
            <div className="bgg-6 bdr-5 bx-sd p-2 text-center h-100">
              <div className="wrap bgi-3 bdr-5 px-1 mb-1 bx-sd bx-sd">
                <div className="icon-s">
                  <img src={getImageUrl(icon)} alt="" />
                </div>
                <h6 className="mx-2 t-regular c-white">{title}</h6>
              </div>
              <div className="row mx--2">
                <div className="col px--1">
                  <div>
                    <div className="t-medium c-white text-center">
                      <small>3ตัวบน</small>
                    </div>
                    <div className="px-1 bg-white bdr-5 bx-sd p-1 text-center">
                      <h5>036</h5>
                    </div>
                  </div>
                </div>
                <div className="col px--1">
                  <div>
                    <div className="t-medium c-white text-center">
                      <small>2ตัวล่าง</small>
                    </div>
                    <div className="px-1 bg-white bdr-5 bx-sd p-1 text-center">
                      <h5>45</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default LotteryResultStaticForeignStock
